module.exports = __webpack_public_path__ + "static/media/hexagon.e09c104c.svg";